import { Checkbox, Spinner, Stack } from '@fluentui/react';
import { useState } from 'react';

import { store, useAppSelector } from '../../../../App/store';
import { actions } from '../../slice';
import AccountField from './AccountField';
import AddressField from './AddressField';
import ExtraTaxFields from './ExtraTaxFields';
import { PhoneInput } from './PhoneInput';

type Props = {
  buttons: (props: { disabled: boolean }) => JSX.Element;
};

export default (props: Props) => {
  const { searchQuery, accountVariables } = store.getState().accounts;
  const submitDisabled = useAppSelector(
    (state) => state.accounts.submitDisabled
  );
  const hasInvoiceAddress = useAppSelector(
    (state) => state.accounts.accountVariables.hasInvoiceAddress
  );

  if (
    hasInvoiceAddress === undefined &&
    accountVariables.shipmentAddress !== accountVariables.invoiceAddress
  ) {
    actions.setAccountVariable(["hasInvoiceAddress", true]);
  }

  return (
    <>
      <AccountField
        label="Hesap Adı"
        variable="name"
        defaultValue={searchQuery}
      />

      <Stack horizontal tokens={stackTokens}>
        <AccountField
          label="VKN / TCKN"
          variable="citizenIdNumber"
          maxLength={11}
        />
        <AccountField label="E-Mail" variable="mailAddress" email />
      </Stack>

      <ExtraTaxFields />

      <Stack horizontal tokens={stackTokens}>
        <PhoneInput label="Telefon" variable="phone0" />
        <PhoneInput label="İkincil Telefon" variable="phone1" />
      </Stack>

      <AddressField
        label="Teslim Adresi"
        variable="shipmentAddress"
        isMultiline
      />

      <Checkbox
        label="Fatura ve teslim adresi aynı"
        checked={!hasInvoiceAddress}
        onChange={(_, checked) => {
          actions.setAccountVariable(["hasInvoiceAddress", !checked]);
        }}
      />

      {hasInvoiceAddress && (
        <AddressField
          label="Fatura Adresi"
          variable="invoiceAddress"
          isMultiline
        />
      )}

      <Stack horizontal horizontalAlign="end" tokens={stackTokens}>
        {submitDisabled && <Spinner />}
        <props.buttons disabled={submitDisabled} />
      </Stack>
    </>
  );
};

const stackTokens = { childrenGap: 15 };
